/* unplugin-vue-components disabled */import { render } from "./OriginalView.vue?vue&type=template&id=19a22bb2&scoped=true"
import script from "./OriginalView.vue?vue&type=script&lang=js"
export * from "./OriginalView.vue?vue&type=script&lang=js"

import "./OriginalView.vue?vue&type=style&index=0&id=19a22bb2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a22bb2"]])

export default __exports__